import React from 'react';
import { useRouteMatch } from 'react-router-dom';

import { buildKnowledgeManagementPath } from '../../../../../app/Routes/orgRouteUtils';
import { Breadcrumbs } from '../../../../../components';
import { LABELS } from '../constants';

type SourceBreadcrumbsProps = {
  knowledgeBaseName?: string;
  knowledgeBaseId: string;
};

export const SourceBreadcrumbs: React.FC<SourceBreadcrumbsProps> = ({
  knowledgeBaseName,
  knowledgeBaseId,
}) => {
  const { params } = useRouteMatch<{ organization_id: string }>();

  return (
    <Breadcrumbs
      className="mb-lg text-small"
      items={[
        {
          label: LABELS.KNOWLEDGE,
          url: buildKnowledgeManagementPath(params.organization_id),
        },
        {
          label: knowledgeBaseName || knowledgeBaseId,
        },
      ]}
    />
  );
};
